import React, { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { DEF_PG_SIZE_WIZARD } from '../../constants/maximum-page-size';
import { useLocale } from '../../contexts/localeContext';
import { TableContextProvider } from '../../contexts/table/TableContextProvider';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { ListData } from '../../models/ListData';
import { ListQuery } from '../../models/ListQuery';
import { Lookup } from '../../models/Lookup';
import { SearchTerm } from '../../models/search/SearchTerm';
import { TableColumn } from '../../models/table/TableColumn';
import TableTab from '../tabs/table-tab';
import Wizard from '../wizard/wizard';
interface AssignModalProps {
    isOpen: boolean,
    onClose: () => any,
    title: string,
    lookup: Lookup[],
    dataMethod: (listParameter?: ListQuery) => Promise<ListData>,
    columnDescriptors: { columns: TableColumn[]; searchColumns: SearchTerm[]; },
    handleOnSubmit: () => any,
    selectedIds: string[],
    setSelectedIds: (selectedIds: string[]) => any,
    tableTitle?: string,
    alwaysSelectedAndDisabled?:string[]
}

const AssignModal: FC<AssignModalProps> = ({ isOpen, onClose, title, lookup, selectedIds, dataMethod, columnDescriptors, handleOnSubmit, setSelectedIds, tableTitle, alwaysSelectedAndDisabled = [] }) => {
    const { translate } = useLocale();
    const onSubmit = () => {
        handleOnSubmit();
        localOnClose();
    }

    const localOnClose = () => {
        onClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <Wizard
                name={title}
                step={0}
                onClose={localOnClose}
                sidebarSteps={[]}
                children={[
                    <div className="overflow-y-auto" style={{ height: '87%' }}>
                        <TableContextProvider
                            dataMethod={dataMethod}
                            tableDescriptor={columnDescriptors.columns}
                            searchDescriptor={columnDescriptors.searchColumns}
                            useTable
                            usePagination
                            useSearch
                            useSort
                            useFilter
                            alwaysSelectedAndDisabled={alwaysSelectedAndDisabled}
                            maxPageSize={DEF_PG_SIZE_WIZARD}
                            lookup={lookup}
                            canExportReport={false}>
                            <TableTab
                                title={tableTitle ? tableTitle : title}
                                selectedIds={selectedIds}
                                setSelectedIds={ setSelectedIds}
                                cyName="assignWizard"
                                />
                        </TableContextProvider>
                    </div>]} />
            <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                <div className="flex flex-row mt-4">
                    <button id='submitAssignButtonId'
                        className="border-portal-blue-primary border-solid border-2 text-portal-blue-primary font-bold py-1 px-5 rounded-lg"
                        type="button" onClick={onSubmit} >
                        {translate.byKey(TranslationKeys.submit)}
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default AssignModal;
